<mat-toolbar class="custom-header">
  <span (click)="guiService.goTo('main/user-nutrition')">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
<div class="container" *ngIf="guiService.userLogged">
  <h2>{{"PROFILE.NUTRITION.QUESTIONNAIRE" | translate}}</h2>
  <div *ngIf="surveyType ==='follow-up'">
    <p class="step">Step {{currentStep}} / {{followUpSteps}}</p>
    <span *ngIf="currentStep === 1" style="display: flex; flex-direction: column;">
      <mat-form-field floatLabel="always">
        <mat-label>{{ 'PROFILE.NUTRITION.SURVEY.UNIT' | translate }}</mat-label>
        <mat-select [(ngModel)]="followUp.unitSystem" required>
          <mat-option value="SYSTEM_IMP">
            {{ 'PROFILE.NUTRITION.SURVEY.SYSTEM_IMP.TEXT' | translate }}
          </mat-option>
          <mat-option value="SYSTEM_MET">
            {{ 'PROFILE.NUTRITION.SURVEY.SYSTEM_MET.TEXT' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('weight')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.WEIGHT' | translate"
          [(ngModel)]="followUp.weight" required inputmode="decimal">
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('weistline')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.WAIST' | translate"
          [(ngModel)]="followUp.weistline" required>
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('hip')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.FLANKS' | translate"
          [(ngModel)]="followUp.hip" required maxlength="5" inputmode="decimal" type="text">
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('rightThigh')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.THIGH_DX' | translate"
          [(ngModel)]="followUp.rightThigh" required maxlength="5" inputmode="decimal" type="text">
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('leftThigh')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.THIGH_SX' | translate"
          [(ngModel)]="followUp.leftThigh" required maxlength="5" inputmode="decimal" type="text">
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('rightArm')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.ARM_DX' | translate"
          [(ngModel)]="followUp.rightArm" required maxlength="5" inputmode="decimal" type="text">
      </mat-form-field>

      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('leftArm')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + followUp.unitSystem + '.ARM_SX' | translate"
          [(ngModel)]="followUp.leftArm" required maxlength="5" inputmode="decimal" type="text">
      </mat-form-field>

    </span>
    <span *ngIf="currentStep === 2" style="display: flex; flex-direction: column;">

      <!-- Campo LIKE -->
      <mat-form-field>
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.LIKE' | translate" [(ngModel)]="followUp.like"
          required>
      </mat-form-field>

      <!-- Campo DISLIKE -->
      <mat-form-field>
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.DISLIKE' | translate" [(ngModel)]="followUp.dislike"
          required>
      </mat-form-field>

      <!-- Campo NEW FOOD -->
      <mat-form-field>
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.NEW_FOOD' | translate" [(ngModel)]="followUp.would"
          required>
      </mat-form-field>

      <!-- Campo CONSIDERATION (textarea) -->
      <mat-form-field [class.missing-field]="lastStepPassed && missingFields.includes('consideration')">
        <textarea matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.CONSIDERATION' | translate" rows="5"
          [(ngModel)]="followUp.consideration">
    </textarea>
      </mat-form-field>

      <!-- Checkbox con termini -->
      <div class="terms">
        <mat-checkbox [(ngModel)]="followUp.terms" class="custom-checkbox">
        </mat-checkbox>

        <ng-container *ngIf="translate.currentLang === 'it'">
          Accetto i vostri
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/terms-of-use/')">
            Termini e condizioni d'uso
          </span>
          e
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/privacy-policy/')">
            l'Informativa sulla privacy
          </span>
        </ng-container>

        <ng-container *ngIf="translate.currentLang === 'en'">
          I accept your
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/terms-of-use/')">
            Terms of Service
          </span>
          and
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/privacy-policy/')">
            Privacy Policy
          </span>
        </ng-container>
      </div>

    </span>

    <div class="footer-position" *ngIf="!isKeyboardOpen">
      <p class="text-center" *ngIf="currentStep > 1" (click)="currentStep = currentStep-1">
        {{"PROFILE.NUTRITION.SURVEY.BACK" | translate}}</p>
      <button class="its-button" *ngIf="currentStep === 1"
        (click)="changeStep('follow-up')">{{"PROFILE.NUTRITION.SURVEY.NEXT" | translate}}</button>
      <button class="its-button" [disabled]="!checkFollowUpPopulated() || btnSpinner" *ngIf="currentStep === 2"
        (click)="sendFollowUp()">
        <ion-spinner name="circular" *ngIf="btnSpinner" style="height: 14px;"></ion-spinner>
        <span *ngIf="!btnSpinner">{{"PROFILE.NUTRITION.SURVEY.SEND" | translate}}</span>
      </button>
    </div>
  </div>
  <div *ngIf="surveyType ==='questionnaire'">
    <p class="step">Step {{currentStep}} / {{questionnaireUpSteps}}</p>
    <span *ngIf="currentStep === 1" style="display: flex; flex-direction: column;">

      <!-- Select sistema unità di misura -->
      <mat-form-field appearance="outline" class="custom-input">
        <mat-select [(ngModel)]="questionnaire.unitSystem" required
          placeholder="{{ 'PROFILE.NUTRITION.SURVEY.UNIT' | translate }}">
          <mat-option value="SYSTEM_IMP">{{ 'PROFILE.NUTRITION.SURVEY.SYSTEM_IMP.TEXT' | translate }}</mat-option>
          <mat-option value="SYSTEM_MET">{{ 'PROFILE.NUTRITION.SURVEY.SYSTEM_MET.TEXT' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Campo NOME -->
      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('name')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.NAME' | translate" [(ngModel)]="questionnaire.name"
          required>
      </mat-form-field>

      <!-- Campo COGNOME -->
      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('surname')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.SURNAME' | translate"
          [(ngModel)]="questionnaire.surname" required>
      </mat-form-field>

      <!-- Campo ETA' -->
      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('age')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.AGE' | translate" [(ngModel)]="questionnaire.age"
          required>
      </mat-form-field>

      <!-- Campo ALTEZZA -->
      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('height')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.HEIGHT' | translate"
          [(ngModel)]="questionnaire.height" required>
      </mat-form-field>

      <!-- Campo PESO -->
      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('weight')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.WEIGHT' | translate"
          [(ngModel)]="questionnaire.weight" required inputmode="decimal">
      </mat-form-field>

    </span>

    <span *ngIf="currentStep === 2" style="display: flex; flex-direction: column;">

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('weistline')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.WAIST' | translate"
          [(ngModel)]="questionnaire.weistline" required maxlength="5" inputmode="decimal" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('hip')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.FLANKS' | translate"
          [(ngModel)]="questionnaire.hip" required maxlength="5" inputmode="decimal" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('rightThigh')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.THIGH_DX' | translate"
          [(ngModel)]="questionnaire.rightThigh" required maxlength="5" inputmode="decimal" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('leftThigh')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.THIGH_SX' | translate"
          [(ngModel)]="questionnaire.leftThigh" required maxlength="5" inputmode="decimal" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('rightArm')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.ARM_DX' | translate"
          [(ngModel)]="questionnaire.rightArm" required maxlength="5" inputmode="decimal" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('leftArm')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.' + questionnaire.unitSystem + '.ARM_SX' | translate"
          [(ngModel)]="questionnaire.leftArm" required maxlength="5" inputmode="decimal" type="text" />
      </mat-form-field>

    </span>

    <span *ngIf="currentStep === 3" style="display: flex; flex-direction: column;">

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('activity')">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.JOB' | translate" [(ngModel)]="questionnaire.activity"
          required type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('lifeStyle')">
        <mat-select [(ngModel)]="questionnaire.lifeStyle"
          placeholder="{{ 'PROFILE.NUTRITION.SURVEY.LIFE' | translate }}" panelClass="custom-inline-mat-select">
          <mat-option *ngFor="let option of stile_vita" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input">
        <mat-select [(ngModel)]="questionnaire.cycle" placeholder="{{ 'PROFILE.NUTRITION.SURVEY.CYCLE' | translate }}">
          <mat-option *ngFor="let option of ciclo" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        *ngIf="questionnaire.cycle === 'Irregolare' || questionnaire.cycle === 'Irregular'">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.CYCLE_FREQ' | translate"
          [(ngModel)]="questionnaire.periodFrequency" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.PATOLOGY' | translate"
          [(ngModel)]="questionnaire.pathologies" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.TERAPY' | translate"
          [(ngModel)]="questionnaire.therapy" type="text" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input">
        <input matInput [placeholder]="'PROFILE.NUTRITION.SURVEY.ALLERGY' | translate"
          [(ngModel)]="questionnaire.allergies" type="text" />
      </mat-form-field>

    </span>

    <span *ngIf="currentStep === 4" style="display: flex; flex-direction: column;">

      <!-- <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('belovedFood')">
        <mat-select [(ngModel)]="questionnaire.belovedFood" multiple
          placeholder="{{ 'PROFILE.NUTRITION.SURVEY.FOOD_LOVE2' | translate }}">
          <mat-option *ngFor="let option of cibi" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="custom-input"
        [class.missing-field]="lastStepPassed && missingFields.includes('hatedFood')">
        <mat-select [(ngModel)]="questionnaire.hatedFood" multiple
          placeholder="{{ 'PROFILE.NUTRITION.SURVEY.FOOD_HATE2' | translate }}">
          <mat-option *ngFor="let option of cibi" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field appearance="outline" class="custom-input">
        <textarea matInput rows="5" [(ngModel)]="questionnaire.consideration"
          [class.missing-field]="lastStepPassed && missingFields.includes('hatedFood')"
          placeholder="{{ 'PROFILE.NUTRITION.SURVEY.CONSIDERATION' | translate }}">
    </textarea>
      </mat-form-field>

      <mat-checkbox class="custom-checkbox" [(ngModel)]="questionnaire.terms">
        <ng-container *ngIf="translate.currentLang == 'it'">
          Accetto i vostri
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/terms-of-use/')">Termini e
            condizioni d'uso</span>
          e
          <span class="link"
            (click)="guiService.goToExternalLink('https://itsdesifit.com/privacy-policy/')">l'Informativa sulla
            privacy</span>
        </ng-container>
        <ng-container *ngIf="translate.currentLang == 'en'">
          I accept your
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/terms-of-use/')">Terms of
            Service</span>
          and
          <span class="link" (click)="guiService.goToExternalLink('https://itsdesifit.com/privacy-policy/')">Privacy
            Policy</span>
        </ng-container>
      </mat-checkbox>

      <span style="color: #fb2b2b;" *ngIf="!checkQuestionnairePopulated()">
        * Campi obbligatori mancanti
      </span>

    </span>

    <div class="footer-position" *ngIf="!isKeyboardOpen">
      <p class="text-center" *ngIf="currentStep > 1" (click)="currentStep = currentStep-1">
        {{"PROFILE.NUTRITION.SURVEY.BACK" | translate}}</p>
      <button class="its-button" *ngIf="currentStep < 4"
        (click)="changeStep('questionnaire')">{{"PROFILE.NUTRITION.SURVEY.NEXT" | translate}}</button>
      <button class="its-button" [disabled]="!checkQuestionnairePopulated() || btnSpinner" *ngIf="currentStep === 4"
        (click)="sendQuestionnaire()">
        <ion-spinner name="circular" *ngIf="btnSpinner" style="height: 14px;"></ion-spinner>
        <span *ngIf="!btnSpinner">{{"PROFILE.NUTRITION.SURVEY.SEND" | translate}}</span>
      </button>
    </div>
  </div>
</div>
